<section class="editor-panel">

  <!-- Tab bar -->
  <div class="editor-tab-bar" *ngIf="!embedded">
    <div [ngClass]="selectedTab === 'CONTENT' ? 'active-content-tab' : 'content-tab'"
         (click)="tabShift('CONTENT')">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="14" height="14"
        fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/>
        <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/>
      </svg>
      Content
    </div>
    <div [ngClass]="selectedTab === 'STYLES' ? 'active-content-tab' : 'content-tab'"
         (click)="tabShift('STYLES')">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="14" height="14"
        fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <circle cx="13.5" cy="6.5" r=".5" fill="currentColor"/>
        <circle cx="17.5" cy="10.5" r=".5" fill="currentColor"/>
        <circle cx="8.5" cy="7.5" r=".5" fill="currentColor"/>
        <circle cx="6.5" cy="12.5" r=".5" fill="currentColor"/>
        <path d="M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10c.926 0 1.648-.746 1.648-1.688 0-.437-.18-.835-.437-1.125-.29-.289-.438-.652-.438-1.125a1.64 1.64 0 0 1 1.668-1.668h1.996c3.051 0 5.555-2.503 5.555-5.554C21.965 6.012 17.461 2 12 2z"/>
      </svg>
      Styles
    </div>
  </div>

  <!-- ── CONTENT ──────────────────────────────────────────────── -->
  <div *ngIf="selectedTab === 'CONTENT' || embedded">
    <!-- <p class="row-desc">Select the {{showImage ? 'image' : 'icon'}} you would like to display</p> -->
    <!-- Upload empty state -->
    <div class="upload-zone" *ngIf="!imageData.url" (click)="updateImage($event)">
      <img src="https://prod-simpo.s3.ap-south-1.amazonaws.com/library-media/354514c1711643199684photo.png" alt=""
        style="height: 36px;">
      <p class="upload-label">Upload a file</p>
      <p class="upload-sub">or select an existing one</p>
      <span class="upload-limit">up to 32MB</span>
      <input type="file" name="myfile" accept="image/x-png,image/gif,image/jpeg,image/jpg" hidden
        (change)="updateImage($event)" class="browse-btn" id="browse_bg_img" #uploadImage />
    </div>

    <!-- Image card with thumbnail + actions -->
    <div class="image-card" *ngIf="imageData?.url || iconData?.url">
      <div class="image-thumb">
        <img [src]="imageData.url" [alt]="imageData.altText" *ngIf="imageLoader === false && showImage">
        <img [src]="iconData.url" [alt]="imageData.altText" *ngIf="imageLoader === false && !showImage">
        <div class="loader-overlay" *ngIf="imageLoader">
          <app-anime-loader></app-anime-loader>
        </div>
        <button class="regenerate-btn" (click)="getUnsplaceImage()">
          <svg *ngIf="!regenerateImageLoader" xmlns="http://www.w3.org/2000/svg" width="13" height="13"
            viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"
            stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
            <path d="M13 2 3 14h9l-1 8 10-12h-9l1-8z"/>
          </svg>
          <svg *ngIf="regenerateImageLoader" xmlns="http://www.w3.org/2000/svg" width="13" height="13"
            viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"
            stroke-linecap="round" stroke-linejoin="round" class="spin-icon" aria-hidden="true">
            <path d="M21 12a9 9 0 1 1-6.219-8.56"/>
          </svg>
          Regenerate
        </button>
      </div>
      <div class="image-actions">
        <button class="btn-replace" (click)="updateImage($event)">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" stroke="currentColor" viewBox="0 0 24 24" width="15" height="15">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.8"
              d="M13.19 8.688a4.5 4.5 0 0 1 1.242 7.244l-4.5 4.5a4.5 4.5 0 0 1-6.364-6.364l1.757-1.757m13.35-.622 1.757-1.757a4.5 4.5 0 0 0-6.364-6.364l-4.5 4.5a4.5 4.5 0 0 0 1.242 7.244"/>
          </svg>
          Replace
        </button>
        <input type="file" name="myfile" accept="image/x-png,image/gif,image/jpeg,image/jpg" hidden
          (change)="updateImage($event)" class="browse-btn" id="browse_bg_img" />
        <button class="btn-delete" (click)="deleteImage()">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" stroke="currentColor" viewBox="0 0 24 24" width="15" height="15">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.8"
              d="m19 7-.8673 12.1425C18.0579 20.1891 17.187 21 16.1378 21H7.86224c-1.04928 0-1.92016-.8109-1.99492-1.8575L5 7m5 4v6m4-6v6m1-10V4c0-.55228-.4477-1-1-1h-4c-.55228 0-1 .44772-1 1v3M4 7h16"/>
          </svg>
          Delete
        </button>
      </div>
    </div>

    <!-- Alt text -->
    <div class="editor-section" *ngIf="imageData.hasOwnProperty('altText') && !compact">
      <p class="prop-label">
        Alt text
        <mat-icon #tooltip="matTooltip" class="info-icon"
          matTooltip="This text will be visible when the image fails"
          matTooltipPosition="right" matTooltipClass="infotooltip" (click)="tooltip.toggle()">info</mat-icon>
      </p>
      <input type="text" placeholder="Enter alt text" class="field-input w-100 mt-6" [(ngModel)]="imageData.altText">
    </div>

    <!-- Link section -->
    <div class="editor-section" *ngIf="!compact">
      <p class="prop-label" style="margin-bottom:10px;">Link</p>
      <div class="seg-buttons">
        <div class="seg-left" (click)="setLinkType('Page')"
          [ngClass]="{'seg-selected': getLinkType() === 'Page'}">Page</div>
        <div class="seg-mid" (click)="setLinkType('section')"
          [ngClass]="{'seg-selected': getLinkType() === 'section'}">Section</div>
        <div class="seg-right" (click)="setLinkType('External')"
          [ngClass]="{'seg-selected': getLinkType() === 'External'}">External</div>
      </div>

      <!-- Page select -->
      <div class="mt-10" *ngIf="getLinkType() === 'Page'">
        <p class="prop-label" style="margin-bottom:6px;">Page</p>
        <div class="custom-select-wrap">
          <select [(ngModel)]="getLinkObject().pageId" (ngModelChange)="onPageChange($event)">
            <option value="" disabled>Select page</option>
            <option *ngFor="let page of templatePage" [value]="page.id">{{page.pageName}}</option>
          </select>
        </div>
      </div>

      <!-- Section select -->
      <div class="mt-10" *ngIf="getLinkType() === 'section' && templatePage?.length">
        <p class="prop-label" style="margin-bottom:6px;">Section</p>
        <div class="custom-select-wrap">
          <select [(ngModel)]="getLinkObject().pageId">
            <option value="" disabled>Select section</option>
            <option *ngFor="let section of templatePage[currentPageIndex]?.components" [value]="section.id">
              {{section.sectionName}}
            </option>
          </select>
        </div>
      </div>

      <!-- External URL -->
      <div class="mt-10" *ngIf="getLinkType() === 'External'">
        <p class="prop-label" style="margin-bottom:6px;">Website URL</p>
        <input type="text" class="field-input w-100" [(ngModel)]="getLinkObject().redirectionUrl"
          placeholder="https://example.com">
      </div>

      <!-- Open in new tab -->
      <div class="prop-row mt-10">
        <span class="prop-label">Open in new tab</span>
        <input class="toggle-input" type="checkbox" [(ngModel)]="getLinkObject().newTab"
          role="switch" [class.active]="getLinkObject().newTab">
      </div>
    </div>

  </div>

  <!-- ── STYLES ────────────────────────────────────────────────── -->
  <div *ngIf="selectedTab === 'STYLES' && !embedded">

    <!-- Crop position (focal point) -->
    <div class="editor-section" *ngIf="imageData.hasOwnProperty('position')">
      <p class="prop-label" style="margin-bottom:10px;">Crop position (focal point)</p>
      <div class="slider-row">
        <label class="slider-label">Horizontal</label>
        <input class="range-slider" [min]="min" [max]="max" step="5" type="range"
          [(ngModel)]="imageData.position.x" (input)="horizontalPosition()">
        <span class="slider-pct">{{imageData.position.x}}%</span>
      </div>
      <div class="slider-row mt-8">
        <label class="slider-label">Vertical</label>
        <input class="range-slider" [min]="min" [max]="max" step="5" type="range"
          [(ngModel)]="imageData.position.y" (input)="horizontalPosition()">
        <span class="slider-pct">{{imageData.position.y}}%</span>
      </div>
    </div>

  </div>

</section>
